import { call, put, takeEvery } from 'redux-saga/effects';
import { SalesAdminActionKeys, UpdateSaObject } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { lookupActionCreators } from '../../lookups';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateSalesAdminObj } from '../salesAdminApi';

function* updateSaObjectSaga(action: UpdateSaObject) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IApiExecuteRespone<any> = yield call(
    updateSalesAdminObj,
    action.payload.endpoint,
    action.payload.value
  );

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(lookupActionCreators.setLookups({ partial: true, payload: { [action.payload.type]: [response.value] } }));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateSaObject() {
  yield takeEvery(SalesAdminActionKeys.UPDATE_SALES_ADMIN_OBJECT, updateSaObjectSaga);
}
